<template>
  <Motivos
    titulo-pagina="Discordo do vendedor"
    url-api="/refund-request/disagree/categories"
    :mostrar-outros="false"
    proxima-pagina="/acompanhar-solicitacao-reembolso/discordar"
  />
</template>

<script>
import Motivos from '@/components/Motivos.vue';

export default {
  name: 'MotivosDiscordar',

  components: {
    Motivos,
  },

  data() {
    return {
    };
  },

};
</script>

<style lang="scss">
  .paddingBottom{
    padding-bottom: 0!important
  }
</style>
